var utilities = {
  utilities: {
    cable: {
    id: "5",
    txt_id: "cable",
    name: "Cable",
    description: null,
    default_icon_location: null
    },
    electricity: {
    id: "1",
    txt_id: "electricity",
    name: "Electricity",
    description: null,
    default_icon_location: null
    },
    internet: {
    id: "4",
    txt_id: "internet",
    name: "Internet",
    description: null,
    default_icon_location: null
    },
    gas: {
    id: "3",
    txt_id: "gas",
    name: "Natural Gas",
    description: null,
    default_icon_location: null
    },
    water: {
    id: "2",
    txt_id: "water",
    name: "Water",
    description: null,
    default_icon_location: null
    },
    heat: {
    id: "6",
    txt_id: "heat",
    name: "Heat",
    description: null,
    default_icon_location: null
    }
  }  
}

module.exports = utilities
